const dataSelectArrowUp = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M8 13V3.6"/><polyline points="5.5 6.14 8.02 3 10.5 6.08"/></svg>',
};

export { dataSelectArrowUp as default };
